import React from 'react';


const PrivacyPolicy = () => {
  return (
    <div className="container mt-5">
      <h1 className="mb-4">Terms and Conditions</h1>

      <section className="mb-4">
        <h2>1. Introduction</h2>
        <p>
          Welcome to FuelTally, a mobile application designed for efficient petrol management. The app provides features such as point reading systems for workers, amount collection entries, and detailed summaries. By using this app, you agree to comply with and be bound by the following terms and conditions. Please review them carefully.
        </p>
      </section>

      <section className="mb-4">
        <h2>2. Acceptance of Terms</h2>
        <p>
          By accessing or using FuelTally, you agree to be bound by these terms and conditions. If you do not agree with these terms, you must discontinue using the app immediately.
        </p>
      </section>

      <section className="mb-4">
        <h2>3. Account Registration</h2>
        <p>
          To access certain features of FuelTally, you may need to create an account. You agree to provide accurate, current, and complete information during registration and to update your details as necessary. You are responsible for maintaining the confidentiality of your account and password and for restricting access to your mobile device.
        </p>
      </section>

      <section className="mb-4">
        <h2>4. Service Description</h2>
        <ul className="list-unstyled">
          <li>Point reading systems corresponding to workers</li>
          <li>Amount collection entries</li>
          <li>Summary generation and detailed reports</li>
          <li>Data analysis tools for petrol usage</li>
        </ul>
      </section>

      <section className="mb-4">
        <h2>5. Payment and Charges</h2>
        <p>
          Certain features of the app may require payment. You agree to pay all applicable charges for premium features. All fees are non-refundable once the purchase is made.
        </p>
      </section>

      <section className="mb-4">
        <h2>6. Refund Policy</h2>
        <p>
          <strong>No Refunds:</strong> All purchases made within the app are final and non-refundable. Please review the feature details carefully before making a purchase.
        </p>
      </section>

      <section className="mb-4">
        <h2>7. Privacy Policy</h2>
        <h3>a) Data Collection</h3>
        <p>
          We collect personal information voluntarily provided by you during account registration, such as your name, email address, and payment information. The app may also automatically collect data such as usage information and device details.
        </p>

        <h3>b) Use of Information</h3>
        <p>
          Your personal information is used to:
          <ul className="list-unstyled">
            <li>Provide and improve our services</li>
            <li>Process payments and generate summaries</li>
            <li>Communicate with you about app updates or promotional offers</li>
          </ul>
        </p>

        <h3>c) Data Protection</h3>
        <p>
          We implement appropriate measures to protect your data against unauthorized access, alteration, or disclosure. However, no system is entirely secure, and we cannot guarantee absolute security.
        </p>

        <h3>d) Sharing of Information</h3>
        <p>
          Your data is not shared with third parties unless necessary to provide app features, comply with legal obligations, or protect our rights.
        </p>
      </section>

      <section className="mb-4">
        <h2>8. Modifications to the Terms</h2>
        <p>
          We reserve the right to update these terms and conditions at any time. Changes will be effective immediately upon posting in the app. Continued use of FuelTally after updates implies acceptance of the revised terms.
        </p>
      </section>

      <section className="mb-4">
        <h2>9. Governing Law</h2>
        <p>
          These terms are governed by the laws of India, and disputes will be resolved in the courts of Jodhpur, Rajasthan.
        </p>
      </section>
    </div>
  );
};

export default PrivacyPolicy;